package pl.decks.posthog

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.decodeFromDynamic
import kotlinx.serialization.json.encodeToDynamic

val jsonEncodeDefaults = Json { encodeDefaults = true }

@OptIn(ExperimentalSerializationApi::class)
inline fun <reified T> T.toDynamic(): dynamic = jsonEncodeDefaults.encodeToDynamic(this)

@OptIn(ExperimentalSerializationApi::class)
inline fun <reified T> fromDynamic(obj: dynamic): T = jsonEncodeDefaults.decodeFromDynamic(obj)
